import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Service from '@/views/Service.vue'
import News from '@/views/News.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import Insurance from '@/views/Insurance.vue'
import InsuranceDetail from '@/views/InsuranceDetail.vue'
import Cpic from '@/views/Cpic.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/contact', component: Contact },
    { path: '/service', component: Service },
    { path: '/products', redirect: '/insurance' },
    { path: '/news', component: News },
    { path: '/news/:id', component: NewsDetail },
    { path: '/insurance', component: Insurance },
    { path: '/insurance/:id', component: InsuranceDetail },
    ...Array.from({ length: 20 }, (_, i) => {
      const id = i + 1
      return {
        path: `/bx${id}`,
        component: Cpic,
        meta: { hideLayout: true, cpicId: id }
      }
    })
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

